import { createContext, useState, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const initialPreviewData = {
  id: '',
  text: '',
  isStreamingComplete: false,
  previewMessages: [],
  errorCode: undefined
};
export const CopilotPreviewContext = /*#__PURE__*/createContext({
  previewData: initialPreviewData,
  updatePreviewData: () => {},
  resetPreviewData: () => {}
});
export const CopilotPreviewContextProvider = ({
  children
}) => {
  const [previewData, setPreviewData] = useState(initialPreviewData);
  const updatePreviewData = useCallback(partialData => {
    setPreviewData(prevData => Object.assign({}, prevData, partialData));
  }, []);
  const resetPreviewData = useCallback(() => {
    setPreviewData(initialPreviewData);
  }, []);
  const contextValue = {
    previewData,
    updatePreviewData,
    resetPreviewData
  };
  return /*#__PURE__*/_jsx(CopilotPreviewContext.Provider, {
    value: contextValue,
    children: children
  });
};